import type { HelpFile } from '../../types/help'
import { LifecycleEventsTestIds } from '../../../testids/LifecycleEventsTestIds'

export const lifecycleEventsHelp: HelpFile = {
  docPage: '/docs/admin/lifecycle-events',
  texts: {
    [LifecycleEventsTestIds.lifecycleEventsList]:
      'Übergreifende Zeitleiste aller Identitäts- und Kontostatusänderungen — filtern, sortieren und blättern für Compliance-Auswertungen.',
    [LifecycleEventsTestIds.lifecycleEventsLoading]: null,
    [LifecycleEventsTestIds.lifecycleEventsEmpty]:
      'Keine Lebenszyklus-Ereignisse entsprechen den aktuellen Filtern. Über "Filter zurücksetzen" alle Filter aufheben.',
    [LifecycleEventsTestIds.colChangedAt]:
      'Zeitpunkt des Übergangs — gestützt auf die changed_at-Spalte in identity_lifecycle_events / account_status_events.',
    [LifecycleEventsTestIds.colEntity]:
      'Entitätstyp — IDENTITY oder ACCOUNT — mit Link zur betroffenen Entität.',
    [LifecycleEventsTestIds.colFromTo]:
      'Vorheriger und neuer Status. Erstellungseinträge zeigen "Erstellt · <toState>", da kein fromState vorliegt.',
    [LifecycleEventsTestIds.colTriggerSource]:
      'Welcher Geschäftsprozess die Änderung ausgelöst hat (USER_ACTION, JML_LEAVER, EXIT_DATE_JOB usw.).',
    [LifecycleEventsTestIds.colActor]:
      'Der ausführende Benutzer. Systemgesteuerte Übergänge zeigen ein "System"-Etikett mit dem auslösenden Prozess.',
    [LifecycleEventsTestIds.colReason]:
      'Freitext-Begründung zum Zeitpunkt des Übergangs. Auf 60 Zeichen gekürzt; vollständiger Text per Hover.',
  },
}
